<footer
  class="footer section section__bg-gradient-parent"
  role="contentinfo"
  aria-label="Site Footer"
>
  <div class="footer__gradient section__bg-gradient" aria-hidden="true"></div>

  <div class="footer__inner container">
    <div class="footer__nav">
      <a class="footer__brand" routerLink="/" aria-label="EVRN home">
        <img
          class="footer__logo"
          src="/assets/hero/logotype.svg"
          alt="EVRN"
          width="128"
          height="126"
        />
      </a>

      <div class="footer__nav-groups">
        @for (navGroup of footerNavGroups; track navGroup.title) {
          <nav class="footer__nav-group" [attr.aria-label]="navGroup.title">
            <p class="footer__nav-group-title type-label-l2">{{ navGroup.title }}</p>

            <div class="footer__nav-links">
              @for (item of navGroup.links; track item.label) {
                @if (item.type === 'internal') {
                  <a
                    class="footer__nav-link type-label-l2"
                    [routerLink]="item.routerLink"
                    [fragment]="item.fragment"
                  >
                    {{ item.label }}
                  </a>
                } @else {
                  <a class="footer__nav-link" [href]="item.href" [target]="item.target">{{
                    item.label
                  }}</a>
                }
              }

              @if (navGroup.showCookiePreferences) {
                <button
                  type="button"
                  class="footer__nav-link footer__nav-link--button type-label-l2"
                  (click)="openCookiePreferences()"
                >
                  Cookie Preferences
                </button>
              }
            </div>
          </nav>
        }
      </div>
    </div>

    <div class="footer__statement">
      <img
        class="footer__preview"
        src="/assets/footer/footer-preview.png"
        loading="lazy"
        width="2560"
        height="570"
        alt="Footer preview"
        aria-hidden="true"
      />
    </div>

    <div class="footer__meta">
      <p class="footer__copy type-caption-c3">EVRN. Los Angeles. Established 2026.</p>

      <div class="footer__social-links type-caption-c3" aria-label="Social links">
        @for (item of socialLinks; track item.label) {
          @if (item.type === 'external') {
            <a
              class="footer__social-link"
              [href]="item.href"
              [target]="item.target"
              rel="noopener noreferrer"
            >
              {{ item.label }}
            </a>
          }
        }
      </div>
    </div>
  </div>
</footer>
